import { Components } from "@thisgorilla/primate-ds";
import { Formik } from "formik";
import { useTheme } from "styled-components";

import { API_CALLS } from "../../../../../API/api_calls";
import { Divider } from "../../../../../commonStyles";
import { useAppSelector } from "../../../../../redux";
import { ArticleProps } from "../../../../../redux/slices/article/Article";
import {
  default_post_id,
  isFormSubmitButtonDisabled,
} from "../../../../../utils";
import { SliderDropdown } from "../../../../Common";
import { FlexRowEnd } from "../../../../Common/Styles";
import Input from "../../../../Input";
import { useFindContent } from "../../useFindContent";
import SliderProps from "./Slider";
import { CreateSlidetContainer, SliderOptionContainer } from "./style";

const CreateSlider = ({
  setIsSliderCreated,
  id,
}: SliderProps.CreateSliderProps) => {
  const { typography } = useTheme();
  const { emojis } = useAppSelector((state) => state.me);
  const emojiIds = Object.keys(emojis);
  const {
    content_data,
    article_order,
    content_id,
    content_type,
    post_id,
    row_config,
  } = useFindContent(id) as ArticleProps.WithRatingContent;
  const { question } = content_data;
  const is_left_emoji_id_valid = content_data.left_emoji_id !== default_post_id;
  const is_right_emoji_id_valid =
    content_data.right_emoji_id !== default_post_id;

  return (
    <Formik
      initialValues={{
        slider_question: question,
        left_emoji_id: is_left_emoji_id_valid
          ? content_data.left_emoji_id
          : emojiIds[0],
        right_emoji_id: is_right_emoji_id_valid
          ? content_data.right_emoji_id
          : emojiIds[1],
      }}
      onSubmit={() => {}}
    >
      {(formik) => {
        const { values, setFieldValue } = formik;
        const { right_emoji_id, left_emoji_id, slider_question } = values;
        return (
          <CreateSlidetContainer>
            <FlexRowEnd>
              <Components.IconButton
                disabled={false}
                iconType="X"
                kind="Secondary"
                size="Small"
                onClick={() =>
                  API_CALLS.ARTICLE.deleteASingleArticleContent(id)
                }
              />
            </FlexRowEnd>
            <Divider />
            <Input
              fieldName="slider_question"
              idPrefix="create-slider"
              isRequired
              placeholder="Ask your question"
              label="Question"
              size="Large"
              maxCount={140}
              helpText={`${slider_question?.length ?? 0}/140 characters`}
              helpTextKind={slider_question?.length ? "Positive" : "Normal"}
            />
            <Divider />
            <Components.Text
              text="Add rating options"
              style={{ tokenStyle: typography.Body.M }}
            />
            <SliderOptionContainer>
              <SliderDropdown
                onValueChange={(value) => setFieldValue("left_emoji_id", value)}
                selectedId={left_emoji_id}
                otherSelectedId={right_emoji_id}
              />
              <SliderDropdown
                onValueChange={(value) =>
                  setFieldValue("right_emoji_id", value)
                }
                selectedId={right_emoji_id}
                otherSelectedId={left_emoji_id}
              />
            </SliderOptionContainer>
            <FlexRowEnd>
              <Components.Button
                color="Primary"
                kind="Primary"
                disabled={isFormSubmitButtonDisabled({
                  formik,
                  requiredFileds: { slider_question: true },
                })}
                label="Save"
                onClick={() => {
                  API_CALLS.ARTICLE.createOrUpdateArticleContent({
                    article_order,
                    content_id,
                    content_type,
                    post_id,
                    element_role: row_config.element_role,
                    content_data: JSON.stringify({
                      question: slider_question,
                      left_emoji_id,
                      right_emoji_id,
                    }),
                  }).then(() => {
                    setIsSliderCreated(true);
                  });
                }}
                size="Medium"
              />
            </FlexRowEnd>
          </CreateSlidetContainer>
        );
      }}
    </Formik>
  );
};

export default CreateSlider;
